import React from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {setGetUsers} from '../../../users/store/thunk/setGetUsers';
import TableCasino from '../../../../../@casino/ui/tableSelect';
import {rows, columns, useStyles} from './helpers';

const BonusPersonalIssueList = ({search, setStep, selectId, setSelectId}) => {
    const dispatch = useDispatch();
    const classes = useStyles();
    
    const [order, setOrder] = React.useState('id');
    const [desc, setDesc] = React.useState(false)
    
    React.useEffect(() => {
        dispatch(setGetUsers({
            page: 1,
            rowsPerPage: 10,
            search: '',
            order: 'id',
            desc: false
        }));
    }, []);

    const users = useSelector(state => state.users.list);
    const getRows = React.useMemo(() => rows(users), [users]);

    return (
        <div className={classes.wrapBlock}>
            <TableCasino
                order={(v) => {
                    dispatch(setGetUsers({
                        page: 1,
                        rowsPerPage: 10,
                        search: search,
                        order: v.id,
                        desc: !desc
                    }));
                    setDesc(!desc);
                    setOrder(v.id)
                }}
                pagination
                allPage={users.countPage}
                width={1300}
                perPage={10}
                columns={columns}
                rows={getRows}
                changePage={(v) => dispatch(setGetUsers({
                    page: +v.page+1,
                    rowsPerPage: v.rowsPerPage,
                    search,
                    order,
                    desc
                }))}
                changeRowsPerPage={(v) => dispatch(setGetUsers({
                    page: +v.page + 1,
                    rowsPerPage: v.rowsPerPage,
                    search,
                    order,
                    desc
                }))}
                setStep={setStep}
                selectId={selectId}
                setSelectId={setSelectId}
            /> 
        </div>
    )
}

export default BonusPersonalIssueList; 